'use strict';

export class CatalogSlider
{

    constructor(offers = {})
    {
        this.offers = offers
        this.init()
    }

    init()
    {
        const instance = this
        const inputsColl = document.querySelectorAll('.js-color-name-list input[type="radio"]')

        if (inputsColl) {
            inputsColl.forEach((input) => input.addEventListener('change', function (e) {
                e.preventDefault()
                instance.changeColor(input)
            }))
        }
    }

    changeColor(input)
    {
        const instance = this
        let color = input.value
        instance.color = color;

        instance.changeSKU()
    }

    changeSKU()
    {
        let color = this.color

        if (this.offers !== null) {
            let img = document.querySelector('.js-img-list[data-item-id="'+ this.offers[color].ID_ITEM +'"]')
            let price = document.querySelector('.js-price-list[data-item-id="'+ this.offers[color].ID_ITEM +'"]')
            let priceOld = document.querySelector('.js-price-old-list[data-item-id="'+ this.offers[color].ID_ITEM +'"]')
            let basketBtn = document.querySelector('.js-add-to-basket[data-item-id="'+ this.offers[color].ID_ITEM +'"]')
            let basketBtnAdded = document.querySelector('.js-added[data-item-id="'+ this.offers[color].ID_ITEM +'"]')

            if (img) {
                img.setAttribute('src', this.offers[color].PREVIEW_PICTURE)
            }

            if (price) {
                price.innerHTML = this.offers[color].PRICE
            }
            
            if (priceOld) {
                priceOld.innerHTML = this.offers[color].PRICE_OLD
            }

            if (basketBtn) {
                basketBtn.setAttribute('data-id', this.offers[color].ID)
            }

            if (basketBtnAdded) {
                basketBtnAdded.setAttribute('data-id', this.offers[color].ID)
            }
        }        
    }
}